export enum DialogTypes {
    TEXT = 'text',
    DATE = 'date',
    TEXTAREA = 'textArea',
    OPTIONS = 'options'
}
